import { gql } from '@apollo/client';

export const INBOUND_JOB_CONFIRM_GOODS = gql`
    mutation ConfirmGoods($data: ConfirmGoodsInput!) {
      confirmGoods(data: $data) {
            code
            success
            message
        }
    }`;

export default INBOUND_JOB_CONFIRM_GOODS;
